import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@chakra-ui/react';
import type { CrmPalette } from '@src/components/sco/Admin/AiCrm/crmLane';
import React from 'react';

/** A message as it reads in a thread: tinted, with the corner that points at the sender. */
export function CrmBubble(props) {
  const $ = _c(6);
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      tone: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = t0;
  } else {
    rest = $[1];
    t0 = $[2];
  }
  const tone = t0 === undefined ? "gray" : t0;
  let t1;
  if ($[3] !== rest || $[4] !== tone) {
    t1 = <Box bg="colorPalette.subtle" borderBottomLeftRadius="xs" borderColor="colorPalette.border" borderRadius="lg" borderWidth="1px" colorPalette={tone} fontSize="md" lineHeight="1.6" px={4} py={3} whiteSpace="pre-wrap" {...rest} />;
    $[3] = rest;
    $[4] = tone;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}